import User, { TypesUser } from './user'

export default class Admin extends User {
    // Readonly

    constructor() {
        super()
        this.type = TypesUser.ADMIN
    }

    public fromJSON(json: any): Admin {
        super.fromJSON(json)


        return this
    }
    
    public toJSON(): any {
        return {
            ...super.toJSON(),
        }
    }
}
